import * as yup from "yup";

export const BlockTopicValidation = yup.object({
  topicName: yup.string().required(),
});
